export class RequestQueue {
    private maxConcurrent: number;
    private activeCount: number;
    private queue: (() => void)[];

    constructor(maxConcurrent: number) {
        this.maxConcurrent = maxConcurrent;
        this.activeCount = 0;
        this.queue = [];
    }

    add(requestFn: () => Promise<any>): Promise<any> {
        return new Promise((resolve, reject) => {
            const task = async () => {
                this.activeCount++;
                try {
                    const result = await requestFn();
                    resolve(result);
                } catch (error) {
                    reject(error);
                } finally {
                    this.activeCount--;
                    this.next();
                }
            };

            this.queue.push(task);
            this.next();
        });
    }

    private next() {
        if (this.activeCount < this.maxConcurrent && this.queue.length > 0) {
            const nextTask = this.queue.shift();
            nextTask?.();
        }
    }
}
